import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const percent = Math.round((current / total) * 100);
  return (
    <div className="w-full bg-lightbg rounded-lg h-3 mb-4 overflow-hidden border border-border">
      <div
        className="h-3 bg-accent transition-all duration-500 ease-out"
        style={{ width: `${percent}%` }}
      />
      <span className="sr-only">{current} / {total}</span>
    </div>
  );
};

export default ProgressBar;
